export default __webpack_public_path__ + "static/media/GabrielCharib.be4e1999.webp";